export const SET_STORE = 'SET_STORE'
export const SET_SOCKET_ID = 'SET_SOCKET_ID'
export const SET_CONNECTION_LOG = 'SET_CONNECTION_LOG'
export const SET_SETTINGS = 'SET_SETTINGS'
export const SET_FONT_SIZE = 'SET_FONT_SIZE'
export const SET_MARGIN = 'SET_MARGIN'
export const SET_TABLE_NUMBERS = 'SET_TABLE_NUMBERS'
export const SET_TABLE_NUMBER_DIRTY = 'SET_TABLE_NUMBER_DIRTY'
export const SET_PRE_ORDER_RING = 'SET_PRE_ORDER_RING'
export const SET_NEW_ORDER_RING = 'SET_NEW_ORDER_RING'
export const SET_CURRENT_MINUTE = 'SET_CURRENT_MINUTE'
export const SET_FULLSCREEN = 'SET_FULLSCREEN'
export const SET_NOTIFICATION = 'SET_NOTIFICATION'
export const SHOW_VERSION_DIALOG = 'SHOW_VERSION_DIALOG'
export const SHOW_WELCOME_DIALOG = 'SHOW_WELCOME_DIALOG'
export const SHOW_HASVERSION_DIALOG = 'SHOW_HASVERSION_DIALOG'
